/* eslint-disable @typescript-eslint/no-explicit-any, camelcase */

/**
 * This file is autogenerated, please don't edit it manually.
 * Use this command to regenerate it if you modified Epic experiments:
 * yarn epic:types
 */

/**
 * Epic experiments namespaces with their possible keys.
 * Autogenerated from static/bundles/epic/data/defaults/
 */
import client from 'bundles/epic/client';
import PeerReview from 'bundles/epic/data/defaults/PeerReview.json';
import type { Tags } from 'bundles/epic/lib/EpicTypes';

type Namespace = {
  waitTimeImprovements: any;
  reduceLowValueFeedbackControl: any;
  reduceLowValueFeedbackA: any;
  reduceLowValueFeedbackB: any;
  reduceLowValueFeedbackC: any;
  aiGradingEnabledForE2E: boolean;
  aiGradingEnabledForFileUploads: boolean;
  aiGradingEnabledForFileUploadsForEnterprise: boolean;
  aiGradingEnabledForFileUploadsForPaidConsumer: boolean;
  aiGradingEnabledForEnterpriseAndPaidConsumer: boolean;
  aiGradingRolloutEnabledForAll: boolean;
  fullyAiGraded: boolean;
};

const NAMESPACE = 'PeerReview';

// Adding safe optional chaining to avoid massive changes in unit tests.
client.addDefaults?.([PeerReview as $TSFixMe]);

const PeerReviewEpicClient = {
  get<K extends keyof Namespace>(key: K, tags?: Tags): Namespace[K] {
    return client.get(NAMESPACE, key, tags);
  },

  preview<K extends keyof Namespace>(key: K, tags?: Tags, defaults?: Namespace): Namespace[K] {
    return client.preview(NAMESPACE, key, tags);
  },
};

export default PeerReviewEpicClient;
